export default __webpack_public_path__ + "static/media/injected_wallet_icon.956d575c.svg";